import React from 'react'
import assets from '../assets'
import Button from '../Components/Button'
import './index.css'
import { motion } from 'framer-motion'

const Section3 = ({handleActivePopUp, variants}) => {
  return (
    <div className='section sectionText relative'>
        <img className='planetSystemSec' src={assets.light.section3} alt="System Planet" />
        <img className='lineLight' src={assets.light.section3v2} alt="Line Light" />
        <div className="container-lg flex flexCol alignCenter relative">
            <motion.h3 
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .3 }}
            viewport={{ once: true }}
            className='iconCorner textCenter width70 extraMbottom'>
                ECON is the decentralizad <strong>ECONomy</strong>, where everything is <strong>interconnected, correlated and validated</strong> to optimize <strong>leverage</strong> among all players.
            </motion.h3>
            <Button link={'#contact'} text={'Apply White List Pre-Sale'} handleActivePopUp={handleActivePopUp} popData='white'/>
            {assets.arrowDown}
            
        </div>
    </div>
  )
}

export default Section3